exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DraggableItemIcons__afterItem___24w6r {\n    display: flex;\n\talign-items: center;\n\tmargin-right: -1rem;\n}\n\n.DraggableItemIcons__reorder___3V-Vc button {\n\tpadding-left: 0.5rem;\n    padding-right: 0;\n    margin-right: -0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"afterItem": "DraggableItemIcons__afterItem___24w6r",
	"reorder": "DraggableItemIcons__reorder___3V-Vc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/DraggableItemIcons.icss
// module id = 1500
// module chunks = 0